import { atom } from "recoil"

export const draftRequestIdState = atom({
  key: "atoms/contact/draftRequestIdState",
  default: 0,
})
